import React, { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Reveal, Label, Display } from "./ui";
import { findProduct, productsInCollection } from "./siteData";

export default function ProductDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = findProduct(id);
  const [active, setActive] = useState(0);
  if (!product) return (
    <div className="mx-auto max-w-[1400px] px-6 pt-44 pb-32 lg:px-12" data-testid="product-notfound">
      <Display className="text-4xl">Piece not found.</Display>
      <Link to="/collections" className="mt-6 inline-block text-[#B89B72]">Back to collections</Link>
    </div>
  );
  const related = productsInCollection(product.collection).filter((p) => p.id !== product.id).slice(0, 3);

  return (
    <div className="pt-10 lg:pt-12" data-testid="product-detail-page">
      <section className="mx-auto grid max-w-[1400px] gap-12 px-6 py-14 lg:grid-cols-2 lg:gap-20 lg:px-12">
        <Reveal>
          <div className="overflow-hidden rounded-md"><img src={product.images[active]} alt={product.name} className="aspect-[4/5] w-full object-cover" data-testid="product-main-image" /></div>
          <div className="mt-4 flex gap-4">
            {product.images.map((img, i) => (
              <button key={i} onClick={() => setActive(i)} data-testid={`product-thumb-${i}`}
                className={`overflow-hidden rounded-md border transition-colors ${active === i ? "border-[#B89B72]" : "border-transparent"}`}>
                <img src={img} alt="" className="h-20 w-16 object-cover" />
              </button>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.15} className="lg:pt-6">
          <Label>{product.collection}</Label>
          <h1 className="mt-5 font-display text-4xl font-light tracking-tight sm:text-5xl" data-testid="product-name">{product.name}</h1>
          <p className="mt-3 text-lg text-[#B89B72]">From {product.from}</p>
          <p className="mt-7 leading-relaxed text-[#595959]">{product.description}</p>

          <dl className="mt-9 grid grid-cols-2 gap-y-6 border-t border-black/10 pt-8 text-sm">
            <div><dt className="text-[#595959]">Material</dt><dd className="mt-1 font-medium">{product.material}</dd></div>
            <div><dt className="text-[#595959]">Finish</dt><dd className="mt-1 font-medium">{product.finish}</dd></div>
            <div className="col-span-2"><dt className="text-[#595959]">Available sizes</dt>
              <dd className="mt-2 flex flex-wrap gap-2">{product.sizes.map((s) => <span key={s} className="rounded-full border border-black/15 px-4 py-1.5 text-xs tracking-wide">{s}</span>)}</dd>
            </div>
          </dl>

          <button onClick={() => navigate("/contact", { state: { product: product.name } })}
            className="mt-10 w-full rounded-full bg-[#1A1A1A] px-8 py-4 text-sm tracking-wide text-[#FAF9F6] transition-colors duration-500 hover:bg-[#B89B72] sm:w-auto" data-testid="request-quote-btn">
            Request Quote for this piece
          </button>
        </Reveal>
      </section>

      {related.length > 0 && (
        <section className="mx-auto max-w-[1400px] px-6 py-24 lg:px-12">
          <Reveal><Label>You may also like</Label><Display className="mt-5 text-3xl sm:text-4xl">Related pieces.</Display></Reveal>
          <div className="mt-12 grid gap-8 sm:grid-cols-3">
            {related.map((p, i) => (
              <Reveal key={p.id} delay={i * 0.08}>
                <Link to={`/product/${p.id}`} className="group block" data-testid={`related-${p.id}`}>
                  <div className="overflow-hidden rounded-md"><img src={p.images[0]} alt={p.name} className="aspect-[4/5] w-full object-cover transition-transform duration-700 group-hover:scale-105" /></div>
                  <h3 className="mt-4 font-display text-xl font-light">{p.name}</h3>
                  <p className="mt-1 text-sm text-[#595959]">From {p.from}</p>
                </Link>
              </Reveal>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}